import React from 'react';
import { InfoCardWidget } from '../../../../statisticsWidgets/statisticsWidgets';
import { GoalsAndAveragesChart } from '../../common/charts/goalsAndAveragesChart';

export default ({ data, loading, title, comment, chartData, chartTitle }) => {
  return (
    <InfoCardWidget primaryColor="#ff9230" secondaryColor="#595959" icon="icon-group" title={title} comment={comment}
                    data={data} loading={loading} >
      <GoalsAndAveragesChart data={chartData} title={chartTitle} />
    </InfoCardWidget>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/widgets/goalsAndAverages.js